Object.defineProperty(exports, "__esModule", { value: true });
var signalr_1 = require("@aspnet/signalr");
var log = require("loglevel");
/**
 * Default logger that bridges ILogger implementations with loglevel logging library
 * */
var DefaultLogger = /** @class */ (function () {
    function DefaultLogger() {
    }
    DefaultLogger.prototype.log = function (logLevel, message) {
        switch (logLevel) {
            case signalr_1.LogLevel.Critical:
            case signalr_1.LogLevel.Error:
                log.error(message);
                break;
            case signalr_1.LogLevel.Warning:
                log.warn(message);
                break;
            case signalr_1.LogLevel.Debug:
                log.debug(message);
                break;
            case signalr_1.LogLevel.Trace:
                log.trace(message);
                break;
            case signalr_1.LogLevel.None:
            case signalr_1.LogLevel.Information:
                log.info(message);
                break;
        }
    };
    return DefaultLogger;
}());
exports.DefaultLogger = DefaultLogger;
//# sourceMappingURL=DefaultLogger.js.map